module.exports = "::ng-deep .mat-dialog-container {\n  padding: 0 !important; }\n\n::ng-deep .mat-tab-body-wrapper {\n  height: 100%; }\n\n.ea-full-width {\n  width: 100%;\n  padding-right: 5px; }\n\n.ea-dialog-title {\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  color: #ffffff; }\n\n.ea-dialog-close {\n  font-weight: 500;\n  color: #ffffff;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/pages/management/students/components/pending-subjects/pending-subject.component.scss
// module id = ./src/app/main/content/pages/management/students/components/pending-subjects/pending-subject.component.scss
// module chunks = main